import { IntegrationsPortErrors } from 'modules/Integrations/domain'
import type { SphereIntegrationConfig } from './sphere.integration.config'

export const sphereConfigurationLoader = (): Promise<{
  data: SphereIntegrationConfig | null
  error: IntegrationsPortErrors | null
}> => {
  return Promise.resolve({
    data: {
      obfuscatedApiKey: ''
    },
    error: null
  })
}
